import { Option } from 'funfix-core';
import { List, Record } from 'immutable';
import { CHANGE_CONTEXT, FETCH_CONTEXTS, RECEIVE_CONTEXTS, RECEIVE_DATA_ERROR } from '../actions/Contexts';
export const makeContextsState = Record({
  contexts: List(),
  dataError: false,
  dataErrorMessages: List(),
  initialized: false,
  isContextsLoading: false,
  pendingContextSearchId: undefined,
  selectedContext: Option.none()
});
export default function ContextsReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeContextsState();
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case FETCH_CONTEXTS:
      return state.set('pendingContextSearchId', action.contextSearchId).set('isContextsLoading', true);
    case RECEIVE_CONTEXTS:
      {
        const contextSearchId = action.contextSearchId;
        return state.pendingContextSearchId === contextSearchId ? state.set('contexts', action.contexts).set('isContextsLoading', false).set('dataError', false).set('dataErrorMessages', List()).set('initialized', true).delete('pendingContextSearchId') : state;
      }
    case RECEIVE_DATA_ERROR:
      return state.set('initialized', true).set('dataError', true).set('dataErrorMessages', action.dataErrorMessages);
    case CHANGE_CONTEXT:
      return state.set('selectedContext', Option.some(action.selectedContext));
    default:
      // Flow compile-time validation that we've handled every action
      // prettier-ignore
      action;
      return state;
  }
}